/* eslint-disable no-undef */
import React from 'react';

// @ts-ignore FIXME - Typescript Strict [7016]
import ReactAudioPlayer from 'react-audio-player';
import Highlight from 'react-scale/components/ui/highlight';
import Waves from 'react-scale/components/website/index/Products/examples/waves';
import Timer from 'react-scale/components/website/index/Products/examples/timer';

export const instruction = 'Please transcribe this audio.';

export const code = `client.createAudioSpeechTask({
  "attachment_type": "audio",
  "attachment": "THE_URL_WE_UPLOAD_THIS_TO",
  "verbatim": true,
  "callback_url": "http://www.example.com/callback",
}, (err, task) => {
    // do something with task
});`;
const responseCode = `{
  "transcript": "On the back cover of their final issue was a photograph of an early morning country road, the kind you might find yourself hitchhiking on if you were so adventurous. Beneath it were the words: “Stay Hungry. Stay Foolish.” It was their farewell message as they signed off. Stay Hungry. Stay Foolish. And I have always wished that for myself. And now, as you graduate to begin anew, I wish that for you.
  Stay Hungry. Stay Foolish.
  Thank you all very much.",
  "duration": 0.37
}`;

export const response = (
  <div className="data-collection">
    <Highlight className="javascript" key="highlight-json">
      {responseCode}
    </Highlight>
    <style jsx>{`
      .data-collection {
        height: 180px;
        overflow: scroll;
      }
    `}</style>
  </div>
);

export const example = () => (
  <div className="transcription">
    <div style={{ width: '100%' }}>
      <MusicIcon />
      <h2>steve-jobs-speech.mp3</h2>
      <div className="time">0:00</div>
      <div className="player">
        <svg className="waves">
          <defs>
            <linearGradient id="loaderGradient">
              <stop offset="0%" stopColor="#6bd0e4" />
              <stop offset="33%" stopColor="#604eb1" />
              <stop offset="66%" stopColor="#c88e66" />
              <stop offset="100%" stopColor="#c955a9" />
            </linearGradient>
          </defs>
          <rect
            id="Rectangle-28"
            stroke="url(#loaderGradient)"
            fillRule="evenodd"
            width="100%"
            height="1"
            y="5"
          />
        </svg>
      </div>
    </div>

    <style jsx>{`
      svg {
        width: 100%;
        height: 30px;
      }

      .transcription {
        background: #222228;
        height: 100%;
        padding: 0;
        display: flex;
        text-align: center;
        align-items: center;
        min-height: 240px;
      }

      h2 {
        color: white;
        font-weight: 400;
      }

      .time {
        color: #9aa1ac;
      }

      .profiles {
        height: 70px;
        margin: 20px auto 20px auto;
      }

      .player {
        margin-top: 40px;
        height: 30px;
        width: 100%;
        display: flex;
        align-items: center;
      }

      .waves {
        width: 100%;
      }
    `}</style>
  </div>
);

export const result = (
  <div className="transcription">
    <div>
      <MusicIcon />
      <h2>steve-jobs-speech.mp3</h2>
      <div className="time">
        <Timer />
      </div>
      <div className="player">
        <Waves />
        <div className="audio-player">
          <ReactAudioPlayer src="/static/audio/transcription.mp3" autoPlay />
        </div>
      </div>
    </div>

    <style jsx>{`
      .audio-player {
        display: none;
      }

      .transcription {
        background: #222228;
        height: 100%;
        padding: 0;
        display: flex;
        text-align: center;
        align-items: center;
        min-height: 240px;
      }

      .transcription > div {
        width: 100%;
      }

      h2 {
        color: white;
        font-weight: 400;
      }

      .time {
        color: #9aa1ac;
      }

      .profiles {
        height: 70px;
        margin: 20px auto 20px auto;
      }

      .player {
        margin-top: 40px;
        height: 30px;
        width: 100%;
        display: flex;
        align-items: center;
      }
    `}</style>
  </div>
);

function MusicIcon(props: $FIXME) {
  return (
    <div className="music-icon">
      <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" {...props}>
        <title>Icons 100</title>
        <defs>
          <linearGradient id="musicGradient">
            <stop offset="0%" stopColor="#FD9D52" />
            <stop offset="50%" stopColor="#DD45D3" />
            <stop offset="100%" stopColor="#6A11EA" />
          </linearGradient>
        </defs>
        <path
          fill="url(#musicGradient)"
          d="M22.283 12.734l22.62-5.655a2.5 2.5 0 0 1 3.107 2.424V43.57c0 3.785-3.395 6.45-8 6.45a5.88 5.88 0 0 1-6-5.86 5.82 5.82 0 0 1 4.41-5.647l4.075-1.02a2 2 0 0 0 1.515-1.94V20.99a1 1 0 0 0-1.242-.97l-17.62 4.404a1.5 1.5 0 0 0-1.138 1.456v24.69c0 3.785-3.396 6.45-8 6.45a5.88 5.88 0 0 1-6-5.86 5.82 5.82 0 0 1 4.41-5.647l4.075-1.02a2 2 0 0 0 1.515-1.94v-26.91a3 3 0 0 1 2.273-2.91z"
          fillRule="evenodd"
        />
      </svg>
      <style jsx>{`
        .music-icon {
          background: white;
          width: 60px;
          height: 60px;
          border-radius: 100px;
          margin: 0 auto 0 auto;
          display: flex;
          align-items: center;
        }

        svg {
          width: 40px;
          display: block;
          margin: auto;
        }
      `}</style>
    </div>
  );
}
